__webpack_require__.p = "https://csonews.ust.hk/eta/app/";